<template>
  <div class="header">
    <div class="navigation">
      <div class="nav__logo">
        <router-link class="logo link" :to="{name: 'home'}">
          <img class="logo__img" v-bind:src="logoUrl">
          <span class="logo__text">{{siteName}}</span>
        </router-link>
      </div>

      <div class="main-nav">
        <div class="header-links">
          <a :href="loginLink" class="header-link">{{$t('loginLinkText')}}</a>
          <a
              :href="signupLink"
              class="header-link btn"
          >{{$t('signupLinkText')}}</a>
        </div>
        <div class="language-component">
          <component v-bind:is="languageDropdownComponent"></component>
        </div>
      </div>
    </div>
    <div class="stage dark-gray">
      <div class="container">
        <h1 class="stage__title">{{$t('headerTitle')}}</h1>
        <h5 class="stage_title--sub">{{$t('headerTitleDescription')}}</h5>
        <component v-bind:is="searchBarComponent"></component>
        <div class="stage__text">
        <span
            class="stage__text__question"
        >{{$t('incorrectPopularQuestion')}}:</span>
          <router-link
              class="link fw4"
              :to="{name: 'article', hash:`#${$store.state.flowObject.variables.popularQuestions[0]}-${popularQuestionOne.title.replace(/ /g, '-')}`}"
          >{{$t('popQues1')}}</router-link>
          <router-link
              class="link fw4"
              :to="{name: 'article', hash:`#${$store.state.flowObject.variables.popularQuestions[1]}-${popularQuestionTwo.title.replace(/ /g, '-')}`}"
          >{{$t('popQues2')}}</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getComponent, getSpecificArticleFromStore } from '@/utils/common';
import { v4 as uuidv4 } from 'uuid';

export default {
  metaInfo() {
    return {
      script: [
        {
          src: `https://www.${this.$store.state.siteDetails.domain_name}/scripts/funnel_hashes.js`,
          callback: () => {
            this.$store.commit('updateFunnelHashes', {funnelHashes, competitorFunnelType})
          }
        }
      ]
    }
  },
  data: () => {
    return {
      showMembersBar: false
    };
  },
  mounted() {
    // let stripeScript = document.createElement('script');
    // stripeScript.setAttribute('src', `https://www.${this.$store.state.siteDetails.domain_name}/scripts/funnel_hashes.js`);
    // stripeScript.onload = () => {
    //   this.funnelHashes = funnelHashes;
    //   this.competitorFunnelType = competitorFunnelType
    // };
    //
    // document.head.appendChild(stripeScript);
  },
  computed: {
    languageDropdownComponent() {
      return getComponent(this.$store.getters.flowObject, 'languageDropdown');
    },
    siteName() {
      return this.$store.state.siteDetails.site_name;
    },
    loginLink() {
      return `https://members.${this.$store.state.siteDetails.domain_name}/login`;
    },
    MALink() {
      return `https://members.${this.$store.state.siteDetails.domain_name}`;
    },
    signupLink() {
      return `https://lp.${this.$store.state.siteDetails.domain_name}/?fl=${this.funnelType}&hash=${this.funnelHash}&lid=${uuidv4()}`;
    },
    logoUrl() {
      if (this.$store.state.siteDetails.domain_name === 'meedyaa.com') {
        return 'https://cdn.milkbox.com/brands/width=32,height=32,fit=contain/2968ea06-3784-4266-9737-51a4df5eaf03/icon.png';
      }
      return this.$store.state.siteDetails.logo_url;
    },
    popularQuestionOne() {
      const question = getSpecificArticleFromStore(this.$store.state.flowObject.variables.popularQuestions[0]);
      return question || { title: '' };
    },
    popularQuestionTwo() {
      const question = getSpecificArticleFromStore(this.$store.state.flowObject.variables.popularQuestions[1]);
      return question || { title: '' };
    },
    searchBarComponent() {
      return getComponent(this.$store.getters.flowObject, 'searchBar');
    },
    funnelType() {
      return this.$store.state.funnelHashes.type;
    },
    funnelHash() {
      return this.$store.state.funnelHashes.hashes[this.funnelType];
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/zeus-design.scss';
.header {
  background: #F5F5F7;
  padding: 0;
}
.navigation {
  max-width: 1430px;
  margin: 0 auto;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 15px;
  .logo {
    display: inline-block;
    vertical-align: top;
    color: #333333;
  }
  .logo__img {
    display: inline-block;
    vertical-align: top;
    height: 50px;
    margin: 0 20px 0 0;
  }
  .logo__text {
    display: inline-block;
    vertical-align: top;
    font-size: 20px;
    margin: 7px 0 0;
  }
}
.nav__logo {
  width: 50%;
}
.main-nav {
  position: relative;
  width: 50%;
  display: flex;
  justify-content: end;
  align-items: center;
  min-width: 378px;
}
.header-links {
  display: flex;
  align-items: center;
}
.header-link {
  color: #333;
  font-size: 16px;
  display: inline-block;
  vertical-align: top;
  text-decoration: none;
  margin: 0 30px 0 0;
  transition: all .2s ease-in-out;
  &:hover {
    text-decoration: underline;
  }
  &.btn {
    margin: 0 60px 0 0;
    min-width: auto;
    text-transform: none;
    color: #fff;
    font-weight: 400;
    padding: 7px 22px 8px;
    &:hover {
      text-decoration: none;
      color: #287EFF;
    }
  }
}
.stage {
  text-align: center;
  padding: 75px 0;
  color: #fff;
  .link:hover {
    text-decoration: underline;
  }
}
.stage__title {
  font-size: 65px;
  font-family:  Segoe UI, Arial, sans-serif;
  font-weight: 400;
  text-transform: uppercase;
  margin: 0;
  color: #fff;
}
.stage_title--sub {
  font-size: 20px;
  font-family: Segoe UI, Arial, sans-serif;
  font-weight: 300;
  margin: 0 0 45px;
  color: #fff;
}
.stage__text {
  max-width: 100%;
  margin: 35px auto 0;
  font-size: 18px;
  font-weight: 600;
  color: #fff;
  span {
    display: inline-block;
    margin: 0 20px 0 0;
  }
  .link {
    color: #fff;
    font-weight: 300;
    display: inline-block;
    margin: 0 20px 0 0;
  }
}
@media (max-width: 768px) {
  .navigation {
    align-items: start;
    padding: 15px;
    .logo {
      margin: 3px 0 0;
    }
    .logo__img {
      height: 30px;
      margin: 0 15px 0 0;
    }
    .logo__text {
      font-size: 16px;
      margin: 3px 0 0;
    }
  }
  .main-nav {
    flex-direction: column;
    align-items: end;
    min-width: 150px;
  }
  .header-links {
    margin: 0 0 15px;
  }
  .header-link {
    margin: 0 15px 0 0;
    &.btn {
      margin: 0;
    }
  }
  .stage {
    padding: 50px 0;
  }
  .stage__title {
    font-size: 45px;
  }
  .stage_title--sub {
    font-size: 18px;
  }
  .stage__text {
    max-width: 100%;
    font-size: 14px;
    span {
      margin: 0 10px 0 0;
      display: block;
    }
    .link {
      margin: 0 10px 0 0;
    }
  }
}
</style>
